import React from 'react';
import { Link } from 'react-router'

function Tools({
                 count,
                 deleteDisciplines
               }) {
  return (
    <div className="admin_list">
      <h5>Disciplines (<span>{count}</span>)</h5>
      <Link className="button_classic" to="/disciplines/new">Add discipline</Link>
      <a className="button_delete" onClick={deleteDisciplines}>Delete</a>

    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/Toolbar/Tools.jsx